/**
 * Add language to customer from the my account page
 * @author Lina Arroyo <lina.arroyo@gradiweb.com>
 */

import { registerEmailInKlaviyo } from '../services/klaviyo';
import { $Q } from "../utils/query-selector";

const axios = require("axios");

const createCustomerWithLang = (email, lang) => {
    registerEmailInKlaviyo(email, lang);
}

let customerID = document.querySelector('#aaamembership_customer_logged_id');

async function getCustomerEmailById(id) {
    if (id) {
        const httpResponse = await axios.get(`https://centrale-fillers-app.herokuapp.com/get_customer?id=${id}`);
        const customerEmail = httpResponse.data.response.body.customer.email;
        return customerEmail;
    }
}

let registerButton = $Q("#my-account-lang-btn");

if (registerButton) {
    registerButton.addEventListener('click', async () => {
        const langSelector = $Q("#dropdown-selector-my-account");
        const customerNewLang = langSelector.options[langSelector.selectedIndex].value;
        const customerEmail = await getCustomerEmailById(customerID.value);
        const successMessage = $Q("#myaccount-lang-success");
        if (customerNewLang) {
            createCustomerWithLang(customerEmail, customerNewLang);
            successMessage.classList.remove("hidden");
        }
    });
}
